<template>
  <v-card
    elevation="0"
    class="vue-json-query-builder bg-transparent"
    :style="{ 'pointer-events': loading ? 'none' : 'all' }"
  >
    <b-card-body class="p-2 bg-transparent" v-if="isVisible">
      <RuleGroup
        :current-query="query"
        :options="options"
        :userId="userId"
        ref="ruleGroup"
      />
    </b-card-body>
  </v-card>
</template>

<script>
import RuleGroup from "@/own/components/orderManagement/promotions/ruleBuilder/RuleGroup.vue";
export default {
  name: "RuleBuilder",
  components: {
    RuleGroup,
  },
  props: {
    query: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    userId: {
      required: false,
    },
  },
  data: function () {
    return {
      isVisible: true,
      loading: false,
    };
  },
  methods: {
    addDefault() {
      this.$refs.ruleGroup.addRule();
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-json-query-builder {
  font-size: 12px;
  user-select: none;
  * {
    font-size: 15px !important;
  }
  .vue-json-query-builder-header {
    cursor: pointer;
  }
}
</style>
